import { h } from "preact";

import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function DealUserOnboardedDialog(props) {
	const handleClose = () => {
		props.onClose();
	};

	const goToDealDashboard = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/05ee85ceb56c4308aabd335f5a4f0169/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//window.location.reload();
						switch (props.state.params.type) {
							case 2:
								window.location.href = "/11d1355181ac4376a09980601b420617/" + props.state.params.deal_uid;
								break;
							case 3:
								window.location.href = "/1fdf58e512f54752959b369588380557/" + props.state.params.deal_uid;
								break;
							case 4:
								window.location.href = "/1fdf58e512f54752959b369588380557/" + props.state.params.deal_uid;
								break;

						}

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Félicitations
				</Typography>
			</DialogTitle>
			<DialogContent dividers>

				<Typography variant="body1">Vous avez complété vos informations personnelles.</Typography>
				<Typography variant="body1">Voulez-vous retourner au dossier de vente ?</Typography>

			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="center" style="width: 100%">
					{/* <Box>
						<Button onClick={handleClose}>Ferme</Button>
					</Box> */}
					<Box>
						<Button onClick={goToDealDashboard} variant="contained">
							Aller au dossier de vente
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
